/**
 * Simple validation utilities
 * Provides basic validation functions that return boolean values
 */

/**
 * Validates that a field is not empty
 */
export function validateRequired(value: string): boolean {
  return value.trim().length > 0;
}

/**
 * Validates that a date string is a valid date
 */
export function validateDate(dateString: string): boolean {
  if (!dateString) return false;
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

/**
 * Validates that a date is in the future
 */
export function validateFutureDate(dateString: string): boolean {
  if (!validateDate(dateString)) return false;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date >= today;
}

/**
 * Validates email format
 */
export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}

/**
 * Validates phone number format (basic)
 */
export function validatePhone(phone: string): boolean {
  const phoneRegex = /^[\d\s\-\+\(\)]{8,}$/;
  return phoneRegex.test(phone.trim());
}

/**
 * Validates that a number is within range
 */
export function validateNumberRange(value: number, min?: number, max?: number): boolean {
  if (isNaN(value) || !isFinite(value)) return false;
  if (min !== undefined && value < min) return false;
  if (max !== undefined && value > max) return false;
  return true;
}

/**
 * Validates string length
 */
export function validateLength(value: string, minLength?: number, maxLength?: number): boolean {
  const length = value.trim().length;
  if (minLength !== undefined && length < minLength) return false;
  if (maxLength !== undefined && length > maxLength) return false;
  return true;
}